/**
 * Route for `link-test-tool`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkTestToolPage } from "../features/link-test-tool/LinkTestToolPage";

export const linkTestToolRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/link-test-tool",
	component: LinkTestToolPage,
});

export default linkTestToolRoute;
